<p *ngFor="let portList of ports">{{ portList.join(', ') }}</p>